import React from 'react';
import { FaTelegram } from 'react-icons/fa'; // Import the Telegram icon
import './telegram.css'; // Import the CSS file for styling

const TelegramButton = () => {
  const phoneNumber = '+94773440937'; // Replace with your actual number
  const telegramLink = `https://t.me/+${phoneNumber}`;

  const message = 'Hello, I need assistance with...'; // Predefined message
  const encodedMessage = encodeURIComponent(message);
 

  return (
    <a href={telegramLink} target="_blank" rel="noopener noreferrer" className="telegram-button">
      <FaTelegram size={40} /> {/* Adjust icon size as needed */}
    </a>
  );
};

export default TelegramButton;


